import {TrackPointsPostRequest, TrackPointsService} from "src/apis/api-client";

/**
 * Tracks a track point for the given component and correlational ids.
 * This is method will only fail internally, as this track points are just for usage tracking.
 *
 * @param component The component name to use. Should be prefixed with WebApp_.
 * @param correlationIds The correlational ids like program or event ids.
 */
export function track(
  component: string,
  correlationIds?: string[]
) {
  try {
    const request: TrackPointsPostRequest = {
      trackPoints: []
    };

    const searchParams = new URLSearchParams(window.location.search);
    searchParams
      .forEach(
        (value, key) => {
          if (key.startsWith('tp_')) {
            request.trackPoints?.push({
              key: key,
              value: value,
              component: component,
              correlationalIds: correlationIds
            });
          }
        }
      );

    if (
      request.trackPoints
      && request.trackPoints.length > 0
    ) {
      TrackPointsService.post(request);
    }
  } catch (error) {
    console.error(error);
  }
}